import { FeedbackData } from '../components/FeedbackButtons';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class FeedbackService {
  /**
   * Submit feedback to Google Sheets via backend
   */
  async submitFeedback(feedbackData: FeedbackData): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit feedback');
      }

      const result = await response.json();
      console.log('Feedback submitted successfully:', result);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }
}

export const feedbackService = new FeedbackService();
export default feedbackService;
